const RESPONSE_EVENT_NAME = `sc:sendMessage:response`;
const messageHandlers = {};
const responseHandlers = {};

const HAS_PARENT = Boolean(window && window.parent !== window);

window.messageHandlers = messageHandlers;
window.responseHandlers = responseHandlers;

function uuid() {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0,
			v = c == "x" ? r : (r & 0x3) | 0x8;

		return v.toString(16);
	});
}

function $sendMessage(msg, target) {
	target = target || window.parent;
	target.postMessage(
		{
			...msg,
			isSinao: true
		},
		`*`
	);
}

async function messageReceived(evt) {
	let msg = evt.data;
	const source = evt.source;

	if (typeof msg === `object`) {
		msg = {
			name: ``,
			data: null,
			isSinao: false,
			...msg,
			handler: null,
			isResponse: Boolean(msg.name === RESPONSE_EVENT_NAME && msg.responseUuid)
		};
	}

	if (!msg.isSinao) {
		return;
	}

	let msgName = msg.name;

	if (msg.isResponse) {
		msgName = msg.responseUuid;
		msg.handler = responseHandlers[msg.responseUuid];
	} else {
		msg.handler = messageHandlers[msg.name];
	}

	if (!msg.handler) {
		return console.log(
			`[frame-manager][${window.origin}][messageReceived] No handler found for message ${msgName}`
		);
	}

	const resData = await msg.handler(msg.data);

	if (msg.respondTo && !msg.isResponse) {
		$sendMessage(
			{
				name: RESPONSE_EVENT_NAME,
				responseUuid: msg.respondTo,
				data: resData
			},
			source
		);
	}
}

function init() {
	if (window && window.addEventListener) {
		window.addEventListener(`message`, messageReceived);
	}
}

function onMessage(name, fn) {
	messageHandlers[name] = fn;
}

function sendMessage(name, data = {}) {
	if (!window || window.parent === window || !window.parent || !window.parent.postMessage) {
		return Promise.resolve();
	}

	return new Promise(resolve => {
		const resUuid = uuid();

		responseHandlers[resUuid] = resData => resolve(resData);

		$sendMessage({
			name,
			data,
			respondTo: resUuid
		});
	});
}

module.exports = frameManager = {
	init,
	onMessage,
	sendMessage,
	hasParentFrame: HAS_PARENT
};
